import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaCog, FaArrowLeft } from 'react-icons/fa';
import AdminMyProfile from '../../../../components/Admin/AdminProfileSetting/AdminMyProfile/AdminMyProfile';
import AdminAccountSetting from '../../../../components/Admin/AdminProfileSetting/AdminAccountSetting/AdminAccountSetting';
import '../../../../assests/css/admin/AdminProfileSetting/AdminProfileSetting.css';

const AdminProfileSetting = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const navigate = useNavigate();

  const tabs = [
    { id: 'profile', label: 'My Profile', icon: <FaUser size={20} /> },
    { id: 'account', label: 'Account Settings', icon: <FaCog size={20} /> },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'profile':  return <AdminMyProfile />;
      case 'account':  return <AdminAccountSetting />;
      default:         return <AdminMyProfile />;
    }
  };

  return (
    <div className="AdminProfileSetting-admin-profile-setting">
      <div className="AdminProfileSetting-sidebar">
        <button
          className="AdminProfileSetting-back-button"
          onClick={() => navigate('/admin/dashboard')}
        >
          <FaArrowLeft size={20} />
          <span>Back to Dashboard</span>
        </button>

        <div className="AdminProfileSetting-sidebar-header">
          <h2>Settings</h2>
        </div>

        <nav className="AdminProfileSetting-sidebar-nav">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`AdminProfileSetting-nav-item ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.icon}
              <span>{tab.label}</span>
            </button>
          ))}
        </nav>
      </div>

      <div className="AdminProfileSetting-main-content">
        {renderContent()}
      </div>
    </div>
  );
};

export default AdminProfileSetting;